import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchMasksConfig = createAction('masks-config/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedMasksConfig = createAction(
  'masks-config/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchedMasksConfig,
  fetchMasksConfig,
};
